import type { ReactNode } from 'react';

export const symbol_nfc_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-574l-73-73q-9-9.07-9-21.53Q38-861 47.05-870q9.06-9 21.5-9Q81-879 90-870l765 765q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q821-54 812-63l-58-57H180Zm0-574v514h514l-60-60H270q-12.75 0-21.37-8.63Q240-257.25 240-270v-364l-60-60Zm120 394h274L300-574v274Zm420-390v305q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-275H393q-3 0-5.5-2.5T385-668v-22.29q0-12.62 8.63-21.17Q402.25-720 415-720h275q12.75 0 21.38 8.62Q720-702.75 720-690Zm120-90v515q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-515H265q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h515q24 0 42 18t18 42ZM437-437Zm86-86Z"
		/>
	</svg>
);
